import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CourseCategory } from '../../store/calendar/model/course-category.model';
import { Course } from '../../store/calendar/model/course.model';
import { Room } from '../../store/calendar/model/room.model';
import { Instructor } from '../../store/calendar/model/instructor.model';
import { TrainingLevel } from '../../store/calendar/model/training-level.model';

@Injectable({
    providedIn: 'root'
})
export class CalendarService {
    constructor(private http: HttpClient) {}

    loadCourseCategories(): Observable<CourseCategory[]> {
        return this.http.get<CourseCategory[]>(`${environment.host}/masterdata/categories`);
    }

    createCourseCategory(category: CourseCategory): Observable<CourseCategory> {
        return this.http.post<CourseCategory>(`${environment.host}/masterdata/categories`, JSON.stringify(category));
    }

    loadCourses(): Observable<Course[]> {
        return this.http.get<Course[]>(`${environment.host}/calendar/courses`);
    }

    createCourse(course: Course): Observable<Course> {
        return this.http.post<Course>(`${environment.host}/calendar/courses`, JSON.stringify(course));
    }

    updateCourse(course: Course): Observable<Course> {
        return this.http.put<Course>(`${environment.host}/calendar/courses/${course.id}`, JSON.stringify(course));
    }

    activateCourse(course: Course): Observable<Course> {
        return this.http.put<Course>(`${environment.host}/calendar/courses/${course.id}/activate`, JSON.stringify(course));
    }

    deactivateCourse(course: Course): Observable<unknown> {
        return this.http.put(`${environment.host}/calendar/courses/${course.id}/deactivate`, JSON.stringify(course));
    }

    deleteCourse(course: Course): Observable<Course> {
        return this.http.delete<Course>(`${environment.host}/calendar/courses/${course.id}`);
    }

    loadRooms(): Observable<Room[]> {
        return this.http.get<Room[]>(`${environment.host}/masterdata/rooms`);
    }

    createRoom(room: Room): Observable<Room> {
        return this.http.post<Room>(`${environment.host}/masterdata/rooms`, JSON.stringify(room));
    }

    loadInstructors(): Observable<Instructor[]> {
        return this.http.get<Instructor[]>(`${environment.host}/usermanagement/users/filter/instructor`);
    }

    loadTrainingLevels(): Observable<TrainingLevel[]> {
        return this.http.get<TrainingLevel[]>(`${environment.host}/masterdata/trainingLevels`);
    }
}
